import Logo, { Logo as NotPureLogo } from './Logo';
import * as Types from './Logo.d';
import { StyledLogo } from './Logo.styled';

export { NotPureLogo as Logo, StyledLogo };
export type LogoProps = Types.LogoProps;
export default Logo;
